function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { constantsRegistry } from '../constants/tableConstantsFactory';
import applyReducer from './applyReducer';
import behaviorCacheUtils from '../utils/behaviorCacheUtils';
const configBehaviorConstants = constantsRegistry('configBehavior');
const refreshCache = (state, action) => {
  behaviorCacheUtils.clearAllBehaviorCaches();
  return _objectSpread(_objectSpread({}, state), {}, {
    list: action.data.slice(0),
    // same list logic as entityReducerFactory
    loading: false,
    // indexed gates ensureConfigBehaviorsReady (CU-86e2np5zw)
    indexed: true
  });
};
const indexFail = state => _objectSpread(_objectSpread({}, state), {}, {
  loading: false,
  // Unblock waiters even when the index fails; list may stay empty.
  indexed: true
});
const reducers = {
  [configBehaviorConstants.INDEX_SUCCESS]: refreshCache,
  [configBehaviorConstants.INDEX_FAIL]: indexFail
};
export default applyReducer(reducers, {});